export default __webpack_public_path__ + "static/media/vault-plus-inactive-button.7be22368.svg";